module.exports = __webpack_public_path__ + "be8a3ecd11fe907739aa58fc0bf078eb.pdf";